// Single source of truth for the running client version. Injected at build
// time from package.json ("version") via REACT_APP_VERSION (see the `build`
// script). The literal fallback keeps dev/test working when the env var isn't
// set — keep it in sync with package.json on release.
export const APP_VERSION = process.env.REACT_APP_VERSION || "4.0.26";

